import { PropTypes } from 'base/react-libs';
import { Button } from '@evertrue/et-components';
import { trackJourneysAction } from 'apps/journeys/utils/helpers/mixpanel';
import { useState, useEffect, forwardRef } from 'react';
import JourneyContactCard from 'apps/journeys/components/journey-contact-card';
import ActiveConstituentActions from './active-constituent-actions';
import moment from 'moment';
import { useIdentity } from 'base/identity-resolver';
import { completeContactJourney } from 'apps/journeys/utils/api-requests/modal-actions';

const ActiveConstituentsRow = forwardRef(
  ({ contactJourney, journey, userIsOwner, openContactSummary, optionalStateManagementFunction, viewSideBar }, ref) => {
    const [currentTask, setCurrentTask] = useState();
    const [nextTask, setNextTask] = useState();
    const {
      org: { id: oid },
    } = useIdentity();

    const [isActive, setIsActive] = useState(false);
    const userName =
      contactJourney && contactJourney.user && contactJourney.user.name ? contactJourney.user.name : 'Evertrue';

    useEffect(() => {
      if (!viewSideBar) {
        setIsActive(false);
      }
    }, [viewSideBar]);

    useEffect(() => {
      let current, next;
      if (contactJourney && contactJourney.tasks && Array.isArray(contactJourney.tasks)) {
        [current, next] = contactJourney.tasks;
        setCurrentTask(current);
        setNextTask(next);
      }
    }, [contactJourney]);

    const removeConstituentFromJourney = async (contactJourney, oid) => {
      const { contact_id, user_id } = contactJourney;
      const { id } = journey;
      const payload = {
        contact_id,
        user_id,
        oid,
        old_journey: {
          id,
          reason: 'COMPLETED',
        },
      };

      await completeContactJourney(payload);

      if (optionalStateManagementFunction) {
        optionalStateManagementFunction('removeContact', { contactIdToRemove: contact_id });
      }
    };

    return (
      <>
        <div
          key={contactJourney.id}
          className={`journeys-constituent-table-row--details ${isActive ? 'active' : ''}`}
          ref={ref}
        >
          <div className="journeys-task-table-contact-card">
            <JourneyContactCard contact={contactJourney.contact} currentJourney={journey} />
          </div>
          {currentTask && currentTask.journey_task ? (
            <>
              <div className="journeys-task-table-row-step-day">
                <div>
                  Current: Step {currentTask.journey_task.step_number} | Day {currentTask.journey_task.day_number}
                </div>
                <div>{currentTask.title}</div>
              </div>
              <div className="journeys-task-table-row--due-date">
                {moment(new Date(currentTask.due_date)).format('MMM Do YYYY')}
              </div>
              <div className="journeys-task-table-row-step-day">
                {nextTask && nextTask.journey_task && (
                  <>
                    <div>
                      Next: Step {nextTask.journey_task.step_number} | Day {nextTask.journey_task.day_number}
                    </div>
                    <div>{nextTask.title}</div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="journey-task-no-next-step">
                No upcoming task for this constituent. <br />
                All the steps in their current cadence have been completed.
              </div>
              {userIsOwner ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button type="secondary" onClick={() => removeConstituentFromJourney(contactJourney, oid)}>
                    Mark Cadence Complete
                  </Button>
                </div>
              ) : (
                <div />
              )}
            </>
          )}
          {userIsOwner ? (
            <>
              <div className="journey-three-dot-view">
                <ActiveConstituentActions
                  journey={journey}
                  contactJourney={contactJourney}
                  optionalStateManagementFunction={optionalStateManagementFunction}
                />
              </div>
            </>
          ) : (
            <div style={{ flex: 1 }}>{userName}</div>
          )}
          <Button
            disabled={!contactJourney.contact}
            onClick={() => {
              trackJourneysAction('view_link');
              const { contact = null } = contactJourney;
              openContactSummary(contact);
              setIsActive(true);
            }}
            type="simple"
          >
            View
          </Button>
        </div>
      </>
    );
  }
);

ActiveConstituentsRow.propTypes = {
  userIsOwner: PropTypes.bool,
  journey: PropTypes.object.isRequired,
  openContactSummary: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
  contactJourney: PropTypes.object,
  viewSideBar: PropTypes.bool,
};
export default ActiveConstituentsRow;
